import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './styles';

export const EditableAcre = ({
  value,
  rowId,
  onAcreUpdate,
  isEditable
}: any) => {
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [acreValue, setAcreValue] = useState(value?.toString() || '');
  const [originalValue, setOriginalValue] = useState(value?.toString() || '');

  const handleEditClick = () => {
    if (!isEditable) return;
    setOriginalValue(value?.toString() || '');
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (!isEditable) return;

    const finalValue = acreValue || '0';

    if (finalValue === originalValue) {
      setIsEditing(false);
      return;
    }

    setIsEditing(false);
    await onAcreUpdate(rowId, finalValue);
  };

  const handleCancelClick = () => {
    if (!isEditable) return;
    setAcreValue(originalValue);
    setIsEditing(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isEditable) return;
    let value = e.target.value;
    value = value.replaceAll(/[^0-9.]/g, '');
    const dotCount = (value.match(/\./g) || []).length;
    if (dotCount > 1) return;
    const [integerPart, decimalPart] = value.split('.');
    if (integerPart.length > 3) return;
    if (decimalPart && decimalPart.length > 2) return;
    setAcreValue(value);
  };

  const displayValue = acreValue || '0';

  if (isEditing && isEditable) {
    return (
      <div className={classes.editableWrapper}>
        <input
          type='text'
          value={acreValue}
          onChange={handleChange}
          className={classes.inputText}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSaveClick();
            if (e.key === 'Escape') handleCancelClick();
          }}
        />
        <IconButton
          size='small'
          onClick={handleSaveClick}
          className={classes.saveIcon}
        >
          <CheckIcon fontSize='small' />
        </IconButton>
        <IconButton
          size='small'
          onClick={handleCancelClick}
          className={classes.crossIcon}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </div>
    );
  }

  return (
    <button
      className={`${classes.root} ${
        isEditable ? classes.pointer : classes.default
      }`}
      onClick={handleEditClick}
    >
      <span className={classes.displayValue}>{displayValue}</span>
      {isEditable && (
        <img
          className={classes.editImg}
          src={`${process.env.PUBLIC_URL}/edit-square.png`}
          alt='edit'
        />
      )}
    </button>
  );
};
